export const formatDate = (inputDate: string) => {
  // Split the date into year, month, and day components
  const [year, month, day] = inputDate.split("-");

  // Rearrange the components in the desired format
  const formattedDate = `${day}/${month}/${year}`;

  return formattedDate;
};
